import { render, staticRenderFns } from "./CustomerTypeDashboard.vue?vue&type=template&id=5d0b9983&"
import script from "./CustomerTypeDashboard.vue?vue&type=script&lang=js&"
export * from "./CustomerTypeDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports